import {
    shape,
    string,
    arrayOf,
    objectOf,
    array,
    bool,
    object,
    oneOf,
    number,
    oneOfType,
} from 'prop-types';
import { APPLICATIONS_GROUPS_NAMES } from './applications';
import { ASSESSMENT_TYPE } from './assessments';
import { PERIOD } from './enrollment';

export const staffType = shape({
    id: string.isRequired,
    firstName: string.isRequired,
    lastName: string.isRequired,
});

const classType = shape({
    gradeLevel: string,
    name: string.isRequired,
    id: string.isRequired,
});
export const classesType = arrayOf(classType);

export const formsType = objectOf(
    shape({
        BOY: array,
        MOY: array,
        EOY: array,
        PM: array,
    }),
);

const applicationType = shape({
    displayName: string.isRequired,
});
export const applicationsType = objectOf(applicationType);

export const institutionType = shape({ name: string.isRequired, hasMultipleInstitutions: bool });

export const classeStudentsType = objectOf(
    shape({
        students: arrayOf(object),
        appStatuses: objectOf(object),
    }),
);

const periodType = oneOf([PERIOD.BOY, PERIOD.MOY, PERIOD.EOY, PERIOD.PM, PERIOD.SUMMER]);

export const bmWindowConfigType = oneOfType([string, object]);

export const gatingRulesConfigType = object;

export const bmWindowType = shape({
    period: periodType.isRequired,
    endDate: oneOfType([string, object]),
    startDate: oneOfType([string, object]),
});

export const assessmentTypeType = oneOf([ASSESSMENT_TYPE.BM, ASSESSMENT_TYPE.PM]);

export const appGroupType = oneOf(APPLICATIONS_GROUPS_NAMES);

export const studentType = shape({
    institution_uid: string.isRequired,
    firstName: string.isRequired,
    middleName: string,
    lastName: string.isRequired,
    grade: string.isRequired,
    isDemo: bool.isRequired,
    dob: string,
    id: string.isRequired,
    appStatuses: objectOf(
        shape({
            BOY: object,
            MOY: object,
            EOY: object,
        }),
    ),
});

export const resultType = shape({
    studentUid: string.isRequired,
    studentTemporalId: string,
    instUid: string.isRequired,
    clientId: string,
    resultId: string.isRequired,
    assessmentDetails: object,
    period: periodType,
    schoolYear: number.isRequired,
    serverModDate: string,
    formUid: string,
    measure: string.isRequired,
    assessment: string.isRequired,
    staffUid: string,
    serverCreateDate: string.isRequired,
    clientCreateDate: string,
    isDiscontinued: bool,
    officialnessRank: number,
    clientModDate: string,
    gradeLevel: string.isRequired,
    isValid: bool,
    measureScores: object,
    isDeleted: bool,
    dataSource: string.isRequired,
    rawScore: number,
    score: number,
    skillName: string,
    interpretation: string,
    maxScore: number,
    canInvalidate: bool,
    modDate: string,
});

export const burstProbeResultType = shape({
    wasDiscontinued: bool.isRequired,
    measure: string.isRequired,
    probeId: number.isRequired,
    clientCreateDate: string.isRequired,
    clientModDate: string.isRequired,
    id: string.isRequired,
    score: number.isRequired,
});

export const burstResultType = shape({
    id: string.isRequired,
    studentId: string.isRequired,
    staffId: string.isRequired,
    clientCreateDate: string.isRequired,
    clientModDate: string.isRequired,
    period: periodType,
    overallScore: number.isRequired,
    measureGenus: string.isRequired,
    results: arrayOf(burstProbeResultType),
});

export const trcResultType = shape({
    studentUid: string.isRequired,
    gradeLevel: string.isRequired,
    staffUid: string,
    period: periodType,
    isComplete: bool.isRequired,
    clientCreateDate: string.isRequired,
    clientModDate: string.isRequired,
    measure: string.isRequired,
    results: arrayOf(
        shape({
            id: string.isRequired,
            trcType: string.isRequired,
            bookTitle: string.isRequired,
            bookUid: number.isRequired,
            isComplete: bool,
            ccTrcLevel: oneOfType([string, object]),
            overallPerf: string,
            resultGroupSeq: number.isRequired,
        }),
    ),
    accessLink: string,
});
